import { EntranceExitChartDtoToEntranceExitChart, EntranceExitChartDtoToEntranceExitTotalChart, EntranceExitTableDtoToEntranceExitTable, } from '../../../../mappers/Reports/entranceExit';
import { getCurrentGroupId } from '../../../../utils/functions';
import { api } from '../../api';
export const EntranceExitApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getEntranceExitTableData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `api/Frota/Manutencoes/${getCurrentGroupId()}`,
                params: {
                    busca: params.term || null,
                    quantidade: params.quantity || 5,
                    pagina: params.page || 1,
                    colunaOrdenacao: params.sorting?.column,
                    direcaoOrdenacao: params.sorting?.direction,
                },
            }),
            transformResponse: (response) => EntranceExitTableDtoToEntranceExitTable(response),
        }),
        getEntranceExitChartData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `api/Frota/Manutencoes/Indicadores/${getCurrentGroupId()}`,
                params: {
                    dataInicio: params.startDate,
                    dataFim: params.endDate,
                    dimensao: params.dimension === 'Mês' ? 'Mes' : params.dimension,
                },
            }),
            transformResponse: (response) => EntranceExitChartDtoToEntranceExitChart(response),
        }),
        getEntranceExitTotalChartData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `api/Frota/Manutencoes/Indicadores/${getCurrentGroupId()}`,
                params: {
                    dataInicio: params.startDate,
                    dataFim: params.endDate,
                    dimensao: params.dimension === 'Mês' ? 'Mes' : params.dimension,
                },
            }),
            transformResponse: (response) => EntranceExitChartDtoToEntranceExitTotalChart(response),
        }),
    }),
});
export const { useGetEntranceExitChartDataQuery, useGetEntranceExitTableDataQuery, useLazyGetEntranceExitChartDataQuery, useLazyGetEntranceExitTableDataQuery, useGetEntranceExitTotalChartDataQuery, useLazyGetEntranceExitTotalChartDataQuery, } = EntranceExitApi;
